import {useMutation, useQueryClient} from '@tanstack/react-query';

import {updateCategory, UpdateCategoryParams} from '../api';
import {QUERY__CATEGORIES, QUERY__CATEGORY} from '../queryKeys';

export const useUpdateCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateCategoryParams) => updateCategory(params),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({queryKey: [QUERY__CATEGORIES]});
      void queryClient.invalidateQueries({
        queryKey: [QUERY__CATEGORY, variables.slug],
      });
    },
  });
};
